module.exports = __webpack_public_path__ + "static/media/country_jeff.84242f10.jpg";